import { render, staticRenderFns } from "./assembly-guide.vue?vue&type=template&id=ce450478&scoped=true&"
import script from "./assembly-guide.vue?vue&type=script&lang=ts&"
export * from "./assembly-guide.vue?vue&type=script&lang=ts&"
import style0 from "./assembly-guide.vue?vue&type=style&index=0&id=ce450478&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce450478",
  null
  
)

export default component.exports